import React, { useCallback, useState } from 'react';

/**
 * Inline value that copies itself to the clipboard on click (text or icon);
 * reuses the copyable-value CSS.
 */
const CopyableValue: React.FC<{ value: string; copyTitle: string }> = ({ value, copyTitle }) => {
  const [flash, setFlash] = useState(false);

  const handleCopy = useCallback(() => {
    navigator.clipboard?.writeText(value).then(() => {
      setFlash(true);
      setTimeout(() => setFlash(false), 600);
    });
  }, [value]);

  return (
    <span
      className={`copyable-value copyable-value--clickable${flash ? ' copyable-value--flash' : ''}`}
      onClick={handleCopy}
      title={copyTitle}
      role="button"
    >
      <span className="copyable-value-text">{value}</span>
      <button type="button" className="copyable-value-btn" aria-label={copyTitle} tabIndex={-1}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
          <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
        </svg>
      </button>
    </span>
  );
};

export default CopyableValue;
